import { useState } from 'react';
import { registerRequest } from '@services/auth/authApi';

// Handles CMS user registration lifecycle for auth screens.
function useRegister() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  async function registerUser(payload) {
    // Success message is kept in hook state so the form can show immediate feedback.
    setError('');
    setSuccess('');
    setIsSubmitting(true);
    try {
      const response = await registerRequest(payload);
      setSuccess(response?.message || 'Usuario CMS registrado correctamente.');
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }

  return { registerUser, isSubmitting, error, success };
}

export default useRegister;
